import { render, staticRenderFns } from "./SDVChart.vue?vue&type=template&id=b0b88910&scoped=true&"
import script from "./SDVChart.vue?vue&type=script&lang=js&"
export * from "./SDVChart.vue?vue&type=script&lang=js&"
import style0 from "./SDVChart.vue?vue&type=style&index=0&id=b0b88910&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b88910",
  null
  
)

export default component.exports